import { createWebpackBackend, defaultI18nConfig } from '@cheqroom/i18n';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

void i18n
	.use(initReactI18next)
	.use(createWebpackBackend())
	.init({
		...defaultI18nConfig,
		debug: process.env.ENVIRONMENT !== 'production',
		ns: ['common', 'accessibility'],
	});

export default i18n;
